import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// 9 sections from backend reportPrompts.js — titles resolved via i18n
const REPORT_SECTIONS = [
  { id: 'activo', num: '01', titleKey: 'editorSections.activo' },
  { id: 'pasivo', num: '02', titleKey: 'editorSections.pasivo' },
  { id: 'patrimonio', num: '03', titleKey: 'editorSections.patrimonio' },
  { id: 'solvencia', num: '04', titleKey: 'editorSections.solvencia' },
  { id: 'liquidez', num: '05', titleKey: 'editorSections.liquidez' },
  { id: 'calidad_activos', num: '06', titleKey: 'editorSections.calidadActivos' },
  { id: 'eficiencia_gestion', num: '07', titleKey: 'editorSections.eficienciaGestion' },
  { id: 'rentabilidad', num: '08', titleKey: 'editorSections.rentabilidad' },
  { id: 'riesgo_interes', num: '09', titleKey: 'editorSections.riesgoInteres' },
];

interface OutlineSectionProps {
  activeSection: string;
  completedSections: string[];
  onSectionSelect: (sectionId: string) => void;
}

export default function OutlineSection({
  activeSection,
  completedSections,
  onSectionSelect,
}: OutlineSectionProps) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);

  // Only count sections that are in REPORT_SECTIONS
  const validSectionIds = REPORT_SECTIONS.map(s => s.id);
  const completedCount = completedSections.filter(id => validSectionIds.includes(id)).length;

  return (
    <div className="outline-section">
      <h3 className="outline-header">{t('editorSections.title')}</h3>

      {/* Cuantitativo accordion */}
      <div className="outline-group">
        <button
          className={`outline-group-header ${isExpanded ? 'expanded' : ''}`}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
          <span>{t('editorSections.quantitative')}</span>
          <span className="outline-count">{completedCount}/{REPORT_SECTIONS.length}</span>
        </button>
        {isExpanded && (
          <ul className="outline-list">
            {REPORT_SECTIONS.map((section) => {
              const isActive = activeSection === section.id;
              const isComplete = completedSections.includes(section.id);

              return (
                <li
                  key={section.id}
                  className={`outline-item ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''}`}
                  onClick={() => onSectionSelect(section.id)}
                >
                  <span className="outline-indicator">{isComplete ? '●' : '○'}</span>
                  <span className="outline-name">{t(section.titleKey)}</span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export { REPORT_SECTIONS };
